import { useEffect } from "react";
import { Card, CardBody, CardTitle } from "reactstrap";
import { Action } from "../../../types/reducer-action";
import AutoFocusDiv from "../../common/auto-focus-div";
import { DataEntryEvent } from "../../common/data-entry-reducer";
import Tabs from "../../common/tabs/tabs";
import UserMemosTab from "./memo/user-memos-tab";
import './style.scss';
import { useUserDispatch, useUserState } from "./user-manager-context";
import UserProfileTab from "./user-profile-tab";
import { toUserProfileForm } from "./useUserApi";

export default function UserDetailsPane() {
  const { dataSet, selectedDataId, dataDetails } = useUserState();
  const dispatch = useUserDispatch();

  useEffect(() => {
    if (selectedDataId && dataSet) {
      const userProfile = dataSet.find(u => u.id === selectedDataId);
      const form = toUserProfileForm(userProfile);
      dispatch(new Action(DataEntryEvent.SetDataDetails, form));
    }
  }, [selectedDataId, dataSet, dispatch]);

  return !dataDetails ? <></> : (
    <Card>
      <CardBody>
        <CardTitle>
          <AutoFocusDiv trigger={dataDetails}>
            User: {dataDetails?.individualName}
          </AutoFocusDiv>
        </CardTitle>

        <Tabs tabs={[
          {
            title: 'User Profile',
            content: <UserProfileTab />
          },
          {
            title: 'Memo',
            content: <UserMemosTab />
          },
        ]} />
      </CardBody>
    </Card>
  );
}
